import { Compass, MapPinned } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { CONTACT_INFO } from "../../constants/site";
import { contactPageData } from "../../data/contactData";

function ContactLocationSection() {
  const { location, details } = contactPageData;
  const officeHours = details.find((detail) => detail.type === "hours")?.value;

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading kicker="Location" title={location.title} description={location.subtitle} />

        <div className="mt-10 grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <article className="rounded-[1.8rem] border border-midnight-navy/10 bg-white/90 p-6 shadow-soft md:p-8">
            <div className="flex items-start gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-glow text-royal-blue">
                <MapPinned className="h-5 w-5" aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-2xl leading-tight">Visit Us in Hyderabad</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-text/80">{CONTACT_INFO.address}</p>
              </div>
            </div>

            <div className="mt-5 rounded-xl bg-sky-glow/75 px-4 py-3 text-sm text-slate-text/85">
              <p className="font-semibold text-midnight-navy">Office Hours</p>
              <p className="mt-1">{officeHours || "Mon - Sat | 10:00 AM - 7:00 PM"}</p>
            </div>

            <a
              href={location.mapHref}
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-midnight-navy px-5 py-3 text-sm font-semibold text-soft-white hover:bg-royal-blue"
            >
              <Compass className="h-4 w-4" aria-hidden="true" />
              {location.mapLabel}
            </a>
          </article>

          <a
            href={location.mapHref}
            target="_blank"
            rel="noreferrer"
            className="group relative block overflow-hidden rounded-[1.9rem] border border-midnight-navy/12 shadow-luxury"
          >
            <img
              src={location.image}
              alt="NextEra Abroad office district"
              className="h-[360px] w-full object-cover transition duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-midnight-navy/75 via-midnight-navy/20 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-r from-royal-blue/10 to-transparent opacity-0 transition group-hover:opacity-100" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-sky-glow/90">
                Office Destination
              </p>
              <p className="mt-2 text-xl text-soft-white">Meet our team for focused, one-on-one guidance.</p>
            </div>
          </a>
        </div>
      </div>
    </MotionSection>
  );
}

export default ContactLocationSection;
